import { render, staticRenderFns } from "./MainCourseVariationFormFields.vue?vue&type=template&id=5259cf7e&"
import script from "./MainCourseVariationFormFields.vue?vue&type=script&lang=js&"
export * from "./MainCourseVariationFormFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports